
    const actividadesJson = [
        {
            "periodo": 1,
            "leccion": 1,
            "actividad": 1,
            "nombre": "¡Luces, cámara, acción!"
        },
        {
            "periodo": 1,
            "leccion": 1,
            "actividad": 2,
            "nombre": "Con cuidado es mejor"
        },
        {
            "periodo": 1,
            "leccion": 1,
            "actividad": 3,
            "nombre": "Evidencia: Siembra una planta en casa"
        },
        {
            "periodo": 1,
            "leccion": 2,
            "actividad": 1,
            "nombre": "Soy creación especial"
        },
        {
            "periodo": 1,
            "leccion": 2,
            "actividad": 2,
            "nombre": "Rasgos que nos hacen únicos"
        },
        {
            "periodo": 1,
            "leccion": 2,
            "actividad": 3,
            "nombre": "Evidencia: Tarjeta "
        },
        {
            "periodo": 1,
            "leccion": 3,
            "actividad": 1,
            "nombre": "Vida para todos"
        },
        {
            "periodo": 1,
            "leccion": 3,
            "actividad": 2,
            "nombre": "Construyamos sociedad "
        },
        {
            "periodo": 1,
            "leccion": 3,
            "actividad": 3,
            "nombre": "Evidencia: Cuidado hacia otros"
        },
        {
            "periodo": 1,
            "leccion": 4,
            "actividad": 1,
            "nombre": "QEPD "
        },
        {
            "periodo": 1,
            "leccion": 4,
            "actividad": 2,
            "nombre": "Hablemos sobre la muerte "
        },
        {
            "periodo": 1,
            "leccion": 4,
            "actividad": 3,
            "nombre": "Evidencia: Carta"
        },
        {
            "periodo": 2,
            "leccion": 1,
            "actividad": 1,
            "nombre": "Amantes de la vida "
        },
        {
            "periodo": 2,
            "leccion": 1,
            "actividad": 2,
            "nombre": "Respeto por la vida "
        },
        {
            "periodo": 2,
            "leccion": 1,
            "actividad": 3,
            "nombre": "Reto: Respetar y valorar la vida"
        },
        {
            "periodo": 2,
            "leccion": 2,
            "actividad": 1,
            "nombre": "Con la vida no se juega"
        },
        {
            "periodo": 2,
            "leccion": 2,
            "actividad": 2,
            "nombre": "Deberes con la vida"
        },
        {
            "periodo": 2,
            "leccion": 2,
            "actividad": 3,
            "nombre": "Leer noticia y responder"
        },
        {
            "periodo": 2,
            "leccion": 3,
            "actividad": 1,
            "nombre": "Dios cuida de mí"
        },
        {
            "periodo": 2,
            "leccion": 3,
            "actividad": 2,
            "nombre": "Crucigrama"
        },
        {
            "periodo": 2,
            "leccion": 3,
            "actividad": 3,
            "nombre": "Escribir testimonio"
        },
        {
            "periodo": 2,
            "leccion": 4,
            "actividad": 1,
            "nombre": "Necesidad + provisión = vida"
        },
        {
            "periodo": 2,
            "leccion": 4,
            "actividad": 2,
            "nombre": "La Provisión de Dios"
        },
        {
            "periodo": 2,
            "leccion": 4,
            "actividad": 3,
            "nombre": "Evidencia: Suplir una necesidas"
        },
        {
            "periodo": 3,
            "leccion": 1,
            "actividad": 1,
            "nombre": "Un nacimiento asombroso"
        },
        {
            "periodo": 3,
            "leccion": 1,
            "actividad": 2,
            "nombre": "Crucigrama "
        },
        {
            "periodo": 3,
            "leccion": 1,
            "actividad": 3,
            "nombre": "Evidencia: Aprecio a Jesús"
        },
        {
            "periodo": 3,
            "leccion": 2,
            "actividad": 1,
            "nombre": "De vuelta a la vida"
        },
        {
            "periodo": 3,
            "leccion": 2,
            "actividad": 2,
            "nombre": "El laberinto "
        },
        {
            "periodo": 3,
            "leccion": 2,
            "actividad": 3,
            "nombre": "Crear plegable"
        },
        {
            "periodo": 3,
            "leccion": 3,
            "actividad": 1,
            "nombre": "Vida que da vida"
        },
        {
            "periodo": 3,
            "leccion": 3,
            "actividad": 2,
            "nombre": "Pirámide social"
        },
        {
            "periodo": 3,
            "leccion": 3,
            "actividad": 3,
            "nombre": "Los invisibles"
        },
        {
            "periodo": 3,
            "leccion": 4,
            "actividad": 1,
            "nombre": "Tu muerte por mi vida "
        },
        {
            "periodo": 3,
            "leccion": 4,
            "actividad": 2,
            "nombre": "¿Por qué murió Jesús?"
        },
        {
            "periodo": 3,
            "leccion": 4,
            "actividad": 3,
            "nombre": "Evidencia: Vive la vida "
        },
        {
            "periodo": 4,
            "leccion": 1,
            "actividad": 1,
            "nombre": "Orando "
        },
        {
            "periodo": 4,
            "leccion": 1,
            "actividad": 2,
            "nombre": "Palabra clave "
        },
        {
            "periodo": 4,
            "leccion": 1,
            "actividad": 3,
            "nombre": "Evidencia: Reunión de oración"
        },
        {
            "periodo": 4,
            "leccion": 2,
            "actividad": 1,
            "nombre": "Soy iglesia, soy vida!"
        },
        {
            "periodo": 4,
            "leccion": 2,
            "actividad": 2,
            "nombre": "la historieta "
        },
        {
            "periodo": 4,
            "leccion": 2,
            "actividad": 3,
            "nombre": "Evidencia: Vive la Vida"
        },
        {
            "periodo": 4,
            "leccion": 3,
            "actividad": 1,
            "nombre": "Muerte en nombre de Dios"
        },
        {
            "periodo": 4,
            "leccion": 3,
            "actividad": 2,
            "nombre": "La persecución "
        },
        {
            "periodo": 4,
            "leccion": 3,
            "actividad": 3,
            "nombre": "Peticiones de oración"
        },
        {
            "periodo": 4,
            "leccion": 4,
            "actividad": 1,
            "nombre": "Una muerte que da vida  "
        },
        {
            "periodo": 4,
            "leccion": 4,
            "actividad": 2,
            "nombre": "Pan y vino "
        },
        {
            "periodo": 4,
            "leccion": 4,
            "actividad": 3,
            "nombre": "Evidencia: Subir fotografía"
        }
    ]

    export default actividadesJson;